import React, { useEffect, useState } from 'react';

import { Section } from 'components/Section';
import { Company } from 'libs/api/invest/generated/schema';

import DashboardHoldersGrid from './DashboardHoldersGrid';
import { HoldersPieChart } from './HoldersPieChart';


export function TopHolders(props: {company: Company, holderName?: string}) {
  return (
    <Section title="Top Investors">
      <div className="d-flex flex-row my-4 break-lines w-100 justify-center">
        <div className="d-flex">
          <HoldersPieChart
            holders={props.company.topHolders}
            dataTipFunction={() => ''}
            chartWidth={280}
            chartHeight={280}
            valueField="holdingsPercent"
          />
        </div>
        <div className="flex-grow-1 p-2">
          <DashboardHoldersGrid
            holderName={props.holderName}
            holders={props.company.topHolders}
            currencySign={window.GLOBAL_CONFIG.CURRENCIES[props.company.currency].sign}
          />
        </div>
      </div>
    </Section>
  );
}
